import { Spinner } from "@heroui/react";
import { ButtonGradient } from "@/components/ButtonGradient";
import { useRunCalc } from "@/hooks/useRunCalc";

const E3RecalculateButton = () => {
  const runCalcMutation = useRunCalc({ client: "e3" });

  const isSubmitting = runCalcMutation.isPending;

  const handleRecalculate = async () => {
    try {
      await runCalcMutation.mutateAsync();
    } catch (err) {
      console.error("Recalculation failed", err);
    }
  };

  return (
    <ButtonGradient
      onPress={handleRecalculate}
      color="purple"
      isDisabled={isSubmitting}
      startContent={isSubmitting ? <Spinner size="sm" color="primary" /> : null}
    >
      {isSubmitting ? "Recalcul..." : "Recalculer"}
    </ButtonGradient>
  );
};

export default E3RecalculateButton;
